export interface FunctionIconOption { value: string; label: string; }

export const FUNCTION_ICON_OPTIONS: FunctionIconOption[] = [
    // PHÍ DỊCH VỤ (Service Fees)
    { value: 'payment', label: '💳 Payment' },
    { value: 'report', label: '📊 Report' },
    { value: 'bill', label: '📋 Bill' },
    { value: 'receivable', label: '💰 Receivable' },
    { value: 'transaction', label: '💸 Transaction' },
    { value: 'money', label: '💰 Money' },
    { value: 'credit-card', label: '💳 Credit Card' },
    { value: 'bank', label: '🏦 Bank' },
    { value: 'invoice', label: '🧾 Invoice' },
    { value: 'receipt', label: '🧾 Receipt' },
    
    // QUẢN LÝ CHÍNH (Main Management)
    { value: 'dashboard', label: '📈 Dashboard' },
    { value: 'settings', label: '⚙️ Settings' },
    { value: 'functions', label: '🔧 Functions' },
    { value: 'home', label: '🏠 Home' },
    { value: 'system', label: '🖥️ System' },
    
    // QUẢN LÝ TÀI KHOẢN (Account Management)
    { value: 'account', label: '👤 Account' },
    { value: 'account-add', label: '➕ Add Account' },
    { value: 'account-edit', label: '✏️ Edit Account' },
    { value: 'permissions', label: '🔐 Permissions' },
    { value: 'permission-add', label: '➕ Add Permission' },
    { value: 'permission-edit', label: '✏️ Edit Permission' },
    { value: 'user', label: '👤 User' },
    { value: 'group', label: '👥 Group' },
    { value: 'security', label: '🔒 Security' },
    
    // QUẢN LÝ CHUNG CƯ (Building Management)
    { value: 'building', label: '🏢 Building' },
    { value: 'building-add', label: '➕ Add Building' },
    { value: 'building-edit', label: '✏️ Edit Building' },
    { value: 'notification', label: '🔔 Notification' },
    { value: 'fee-category', label: '📂 Fee Category' },
    { value: 'fee-category-add', label: '➕ Add Fee Category' },
    { value: 'fee-category-edit', label: '✏️ Edit Fee Category' },
    { value: 'bulk-entry', label: '📥 Bulk Entry' },
    { value: 'pdf-export', label: '📄 PDF Export' },
    { value: 'pdf-template', label: '📋 PDF Template' },
    { value: 'export', label: '📤 Export' },
    { value: 'import', label: '📥 Import' },
    
    // QUẢN LÝ CĂN HỘ (Apartment Management)
    { value: 'search', label: '🔍 Search' },
    { value: 'apartment', label: '🏠 Apartment' },
    { value: 'apartment-add', label: '➕ Add Apartment' },
    { value: 'apartment-edit', label: '✏️ Edit Apartment' },
    { value: 'apartment-details', label: '📋 Apartment Details' },
    { value: 'apartment-group', label: '🏘️ Apartment Group' },
    { value: 'house', label: '🏠 House' },
    { value: 'room', label: '🏠 Room' },
    { value: 'floor', label: '🏢 Floor' },
    
    // QUẢN LÝ CÔNG VIỆC (Task Management)
    { value: 'task-add', label: '➕ Add Task' },
    { value: 'task-list', label: '📋 Task List' },
    { value: 'task-incomplete', label: '⏳ Incomplete Tasks' },
    { value: 'task-completed', label: '✅ Completed Tasks' },
    { value: 'task-details', label: '📋 Task Details' },
    { value: 'work', label: '💼 Work' },
    { value: 'project', label: '📁 Project' },
    { value: 'assignment', label: '📝 Assignment' },
    { value: 'deadline', label: '⏰ Deadline' },
    { value: 'progress', label: '📈 Progress' },
    
    // TIỆN ÍCH TÒA NHÀ (Building Utilities)
    { value: 'building-utility-group', label: '🏢🏠 Building Utility Group' },
    { value: 'building-utility-group-add', label: '➕ Add Building Utility Group' },
    { value: 'building-utility-group-edit', label: '✏️ Edit Building Utility Group' },
    { value: 'building-utility', label: '🏢🔧 Building Utility' },
    { value: 'building-utility-add', label: '➕ Add Building Utility' },
    { value: 'building-utility-edit', label: '✏️ Edit Building Utility' },
    { value: 'building-utility-booking', label: '📅 Building Utility Booking' },
    { value: 'building-utility-booking-add', label: '➕ Add Building Utility Booking' },
    { value: 'building-utility-booking-edit', label: '✏️ Edit Building Utility Booking' },
    { value: 'booking', label: '📅 Booking' },
    { value: 'reservation', label: '📅 Reservation' },
    { value: 'schedule', label: '📅 Schedule' },
    
    // DỊCH VỤ TÒA NHÀ (Building Services)
    { value: 'construction', label: '🏗️ Construction' },
    { value: 'construction-add', label: '➕ Add Construction' },
    { value: 'construction-edit', label: '✏️ Edit Construction' },
    { value: 'entry-exit', label: '🚪 Entry/Exit' },
    { value: 'entry-exit-add', label: '➕ Add Entry/Exit' },
    { value: 'entry-exit-edit', label: '✏️ Edit Entry/Exit' },
    { value: 'moving', label: '📦 Moving' },
    { value: 'moving-add', label: '➕ Add Moving' },
    { value: 'moving-edit', label: '✏️ Edit Moving' },
    { value: 'service', label: '🔧 Service' },
    { value: 'maintenance', label: '🔧 Maintenance' },
    { value: 'repair', label: '🔧 Repair' },
    
    // CHĂM SÓC KHÁCH HÀNG (Customer Care)
    { value: 'feedback', label: '💬 Feedback' },
    { value: 'feedback-details', label: '📋 Feedback Details' },
    { value: 'feedback-category', label: '📂 Feedback Category' },
    { value: 'chat', label: '💬 Chat' },
    { value: 'chat-details', label: '📋 Chat Details' },
    { value: 'support', label: '🎧 Support' },
    { value: 'help', label: '❔ Help' },
    { value: 'customer', label: '👤 Customer' },
    { value: 'service-desk', label: '🎧 Service Desk' },
    
    // TIỆN ÍCH HỆ THỐNG (System Utilities)
    { value: 'email', label: '📧 Email' },
    { value: 'send-email', label: '📤 Send Email' },
    { value: 'email-list', label: '📋 Email List' },
    { value: 'automation', label: '🤖 Automation' },
    { value: 'template', label: '📋 Template' },
    { value: 'notification', label: '🔔 Notification' },
    { value: 'message', label: '💬 Message' },
    { value: 'communication', label: '📞 Communication' },
    
    // CÀI ĐẶT (Settings)
    { value: 'system-settings', label: '⚙️ System Settings' },
    { value: 'user-settings', label: '👤 User Settings' },
    { value: 'configuration', label: '⚙️ Configuration' },
    { value: 'backup', label: '💾 Backup' },
    { value: 'restore', label: '🔄 Restore' },
    { value: 'preferences', label: '⚙️ Preferences' },
    { value: 'profile', label: '👤 Profile' },
    
    // GENERAL ICONS
    { value: 'list', label: '📋 List' },
    { value: 'add', label: '➕ Add' },
    { value: 'edit', label: '✏️ Edit' },
    { value: 'delete', label: '🗑️ Delete' },
    { value: 'view', label: '👁️ View' },
    { value: 'download', label: '⬇️ Download' },
    { value: 'upload', label: '⬆️ Upload' },
    { value: 'print', label: '🖨️ Print' },
    { value: 'filter', label: '🔍 Filter' },
    { value: 'sort', label: '📊 Sort' },
    { value: 'calendar', label: '📅 Calendar' },
    { value: 'clock', label: '🕐 Clock' },
    { value: 'location', label: '📍 Location' },
    { value: 'phone', label: '📞 Phone' },
    { value: 'mobile', label: '📱 Mobile' },
    { value: 'computer', label: '💻 Computer' },
    { value: 'database', label: '🗄️ Database' },
    { value: 'server', label: '🖥️ Server' },
    { value: 'network', label: '🌐 Network' },
    { value: 'cloud', label: '☁️ Cloud' },
    { value: 'lock', label: '🔒 Lock' },
    { value: 'unlock', label: '🔓 Unlock' },
    { value: 'key', label: '🔑 Key' },
    { value: 'shield', label: '🛡️ Shield' },
    { value: 'warning', label: '⚠️ Warning' },
    { value: 'error', label: '❌ Error' },
    { value: 'success', label: '✅ Success' },
    { value: 'info', label: 'ℹ️ Info' },
    { value: 'question', label: '❓ Question' },
    { value: 'star', label: '⭐ Star' },
    { value: 'heart', label: '❤️ Heart' },
    { value: 'like', label: '👍 Like' },
    { value: 'dislike', label: '👎 Dislike' },
    { value: 'share', label: '📤 Share' },
    { value: 'link', label: '🔗 Link' },
    { value: 'bookmark', label: '🔖 Bookmark' },
    { value: 'flag', label: '🚩 Flag' },
    { value: 'tag', label: '🏷️ Tag' },
    { value: 'folder', label: '📁 Folder' },
    { value: 'file', label: '📄 File' },
    { value: 'image', label: '🖼️ Image' },
    { value: 'video', label: '🎥 Video' },
    { value: 'audio', label: '🎵 Audio' },
    { value: 'document', label: '📄 Document' },
    { value: 'spreadsheet', label: '📊 Spreadsheet' },
    { value: 'presentation', label: '📽️ Presentation' },
    { value: 'archive', label: '📦 Archive' },
    { value: 'compressed', label: '🗜️ Compressed' },
    { value: 'code', label: '💻 Code' },
    { value: 'terminal', label: '💻 Terminal' },
    { value: 'bug', label: '🐛 Bug' },
    { value: 'test', label: '🧪 Test' },
    { value: 'deploy', label: '🚀 Deploy' },
    { value: 'monitor', label: '📊 Monitor' },
    { value: 'analytics', label: '📈 Analytics' },
    { value: 'chart', label: '📊 Chart' },
    { value: 'graph', label: '📈 Graph' },
    { value: 'trending', label: '📈 Trending' },
    { value: 'statistics', label: '📊 Statistics' },
    { value: 'ticket', label: '🎫 Ticket' },
    { value: 'order', label: '📦 Order' },
    { value: 'shopping-cart', label: '🛒 Shopping Cart' },
    { value: 'wallet', label: '👛 Wallet' },
    { value: 'atm', label: '🏧 ATM' },
    { value: 'coin', label: '🪙 Coin' },
    { value: 'dollar', label: '💵 Dollar' },
    { value: 'euro', label: '💶 Euro' },
    { value: 'pound', label: '💷 Pound' },
    { value: 'yen', label: '💴 Yen' },
    { value: 'won', label: '₩ Won' },
    { value: 'rupee', label: '₹ Rupee' },
    { value: 'ruble', label: '₽ Ruble' },
    { value: 'bitcoin', label: '₿ Bitcoin' },
    { value: 'ethereum', label: 'Ξ Ethereum' },
    { value: 'cryptocurrency', label: '🪙 Cryptocurrency' },
    { value: 'exchange', label: '💱 Exchange' },
    { value: 'transfer', label: '💸 Transfer' },
    { value: 'deposit', label: '💰 Deposit' },
    { value: 'withdrawal', label: '💸 Withdrawal' },
    { value: 'loan', label: '🏦 Loan' },
    { value: 'mortgage', label: '🏠 Mortgage' },
    { value: 'insurance', label: '🛡️ Insurance' },
    { value: 'tax', label: '💰 Tax' },
    { value: 'discount', label: '🏷️ Discount' },
    { value: 'coupon', label: '🎫 Coupon' },
    { value: 'gift', label: '🎁 Gift' },
    { value: 'reward', label: '🏆 Reward' },
    { value: 'badge', label: '🏅 Badge' },
    { value: 'medal', label: '🥇 Medal' },
    { value: 'trophy', label: '🏆 Trophy' },
    { value: 'crown', label: '👑 Crown' },
    { value: 'diamond', label: '💎 Diamond' },
    { value: 'gem', label: '💎 Gem' },
    { value: 'pearl', label: '🪸 Pearl' },
    { value: 'crystal', label: '💎 Crystal' },
    { value: 'gold', label: '🥇 Gold' },
    { value: 'silver', label: '🥈 Silver' },
    { value: 'bronze', label: '🥉 Bronze' },
    { value: 'platinum', label: '💎 Platinum' }];

export function resolveIconSelectValue(icon?: string): string {
  if (!icon) return 'folder';
  if (FUNCTION_ICON_OPTIONS.some((option) => option.value === icon)) return icon;
  const byEmoji = FUNCTION_ICON_OPTIONS.find((option) => option.label.startsWith(icon));
  if (byEmoji) return byEmoji.value;
  return 'folder';
}

export function getFunctionIconDisplay(icon?: string): string {
  if (!icon) return '📁';
  const option = FUNCTION_ICON_OPTIONS.find((item) => item.value === icon);
  if (option) return option.label.split(' ')[0];
  return icon;
}
